import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ChatbotFiltersContainer } from './ChatbotFiltersContainer';
import { useChatbotFilters } from './useChatbotFilters';
import { useChatbotFiltersEventsSubscribe } from './useChatbotFiltersEventsSubscribe';
import { closeChatbotFiltersModal } from '../../actions/chatbotFiltersModal';
import { ButtonsDesktop } from '../../components/ChatbotFilters/ButtonsDesktop';
import { ButtonsMobile } from '../../components/ChatbotFilters/ButtonsMobile';
import { chatbotFiltersModalSelector } from '../../selectors/chatbotFiltersModalSelector';
import { applyChatbotFilters } from '../../thunks/chatbot';
import { RESET_FILTERS } from '../../types/chatbotFilters';
import { EManifestStatus } from '../../types/chatbotFiltersModal';

export const ChatbotFiltersModalContainer = () => {
  const { isOpened, isFiltersLoading: filtersLoading } = useSelector(chatbotFiltersModalSelector);
  const dispatch = useDispatch();
  const { jsonQuery } = useChatbotFiltersEventsSubscribe();
  const { manifestStatus, getLocalApi, microfrontendRef } = useChatbotFilters();

  const onResetFilters = React.useCallback(() => {
    getLocalApi()[RESET_FILTERS]();
  }, [getLocalApi]);

  const onClose = React.useCallback(() => dispatch(closeChatbotFiltersModal()), [dispatch]);
  const onChangeFilters = React.useCallback(() => {
    /* istanbul ignore next */
    if (!jsonQuery) {
      return;
    }

    dispatch(applyChatbotFilters(jsonQuery));
  }, [dispatch, jsonQuery]);

  const isButtonsDisabled = manifestStatus !== EManifestStatus.Success;

  return (
    <ModalWindow
      open={isOpened}
      onClose={onClose}
      fixed
      width={494}
      title="Настройка поиска"
      footer={
        <>
          <ButtonsDesktop
            isButtonsDisabled={isButtonsDisabled}
            isFiltersLoading={filtersLoading}
            onChangeFilters={onChangeFilters}
            onResetFilters={onResetFilters}
          />
          <ButtonsMobile
            isButtonsDisabled={isButtonsDisabled}
            isFiltersLoading={filtersLoading}
            onChangeFilters={onChangeFilters}
            onResetFilters={onResetFilters}
          />
        </>
      }
    >
      <ChatbotFiltersContainer microfrontendRef={microfrontendRef} />
    </ModalWindow>
  );
};
